// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__cwBOX","checkbox":"TodoItem_checkbox__hEAmT","textInput":"TodoItem_textInput__3J8FA"};